import dayjs from 'dayjs';
import 'dayjs/locale/th';

dayjs.locale('th');

export function formatThaiShortBE(d: string | Date) {
  const beYear2 = (dayjs(d).year() + 543) % 100;
  return `${dayjs(d).format('D MMM')} ${beYear2}`;
}

export function formatThaiShortBEWithTime(d: string | Date) {
  const m = dayjs(d);
  const beYear2 = (m.year() + 543) % 100;
  return `${m.format('DD MMM')} ${beYear2} ${m.format('HH:mm')}`;
}
